/* eslint-disable react/no-children-prop */
import React, { Component } from 'react';
import {
  Card, CardBody, Col, Badge, Table, Spinner, Button
} from 'reactstrap';
import moment from 'moment';
import { Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import DownloadIcon from 'mdi-react/CloudDownloadIcon';
import PropTypes from 'prop-types';
import { subscriptionPlans, _capitalizeText } from '../../../shared/helpers/utils';
import { _axiosCall } from '../../../shared/helpers/apicalls';
import LinearLoading from '../../../shared/components/LinearLoading';
import TagIcon from 'mdi-react/TagOutlineIcon';

const apiUrl = process.env.API_ROOT + '/buyerslist/';
const ITEMS_PER_PAGE = 10;

class Invoices extends Component {
  constructor(props) {
	super(props);
	this.state = {
	  loading: true,
	  invoices: [],
	  hasMore: false,
	  nextStartingAfter: null,
	  startingAfterStack: []
	};
  }

  componentDidMount() {
	const customerId = this.props.customerId || (this.props.user && this.props.user.customerId);
	if (customerId) {
	  this._getInvoices(customerId, null);
	} else {
	  this.setState({ loading: false });
	}
  }

  componentDidUpdate(prevProps) {
	const customerId = this.props.customerId || (this.props.user && this.props.user.customerId);
	const prevCustomerId = prevProps.customerId || (prevProps.user && prevProps.user.customerId);
	if (customerId && customerId !== prevCustomerId) {
	  this._getInvoices(customerId, null);
	}
  }

  _getInvoices = function (customer, starting_after) {
	const userData = {
	  url: apiUrl + 'stripe/get-invoices',
	  method: 'post',
	  query: {
		customer: customer,
		limit: ITEMS_PER_PAGE,
		starting_after: starting_after
	  }
	};

	var self = this;
	self.setState({ loading: true });

	_axiosCall(userData)
	  .then(function (res) {
		if (res && res.data) {
		  self.setState({
			invoices: res.data,
			hasMore: res.has_more,
			nextStartingAfter: res.next_starting_after,
			loading: false
		  });
		} else {
		  self.setState({ invoices: [], loading: false });
		}
	  })
	  .catch(function (error) {
		console.log('_getInvoices error', error);
		self.setState({ invoices: [], loading: false });
	  });
  }.bind(this);

  _handleNext = function () {
	const customerId = this.props.customerId || (this.props.user && this.props.user.customerId);
	const stack = this.state.startingAfterStack.slice();
	stack.push(this.state.invoices[this.state.invoices.length - 1].id);
	this.setState({ startingAfterStack: stack }, function () {
	  this._getInvoices(customerId, this.state.nextStartingAfter);
	});
  }.bind(this);

  _handlePrev = function () {
	const customerId = this.props.customerId || (this.props.user && this.props.user.customerId);
	const stack = this.state.startingAfterStack.slice();
	const prevStartingAfter = stack.length > 1 ? stack[stack.length - 2] : null;
	stack.pop();
	this.setState({ startingAfterStack: stack }, function () {
	  this._getInvoices(customerId, prevStartingAfter);
	});
  }.bind(this);

  render() {
	const { user } = this.props;
	const { invoices, loading, hasMore, startingAfterStack } = this.state;

	const { subscriptionPlan } = user;
	const currentPlan = subscriptionPlans.filter(plan => plan.id === subscriptionPlan)[0];
	if(invoices.length === 0) return null;
	return (
	  <Col md={12} lg={12}>
		<Card className="billing">
		  <CardBody>
			<div className="card__title">
			  <h5 className="bold-text"><TagIcon size={36} /> Invoice History</h5>
			  <h5 className="subhead"></h5>
			</div>

			{loading ? (
			  null
			) : invoices.length === 0 ? (
			  <div style={{ padding: '1rem' }}>No invoices found.</div>
			) : (
			  <div>
				<Table striped responsive>
				  <thead>
					<tr>
					  <th></th>
					  <th>Date</th>
					  <th>Amount Due</th>
					  <th>Description</th>
					  <th>Invoice #</th>
					  <th>Status</th>
					</tr>
				  </thead>
				  <tbody>
					{invoices.map(function (invoice) {
					  return (
						<tr key={invoice.id}>
						  <td style={{ padding: '3px 5px' }}>
							<Tooltip title="Download Invoice as PDF">
							  <IconButton
								className="material-table__toolbar-button"
								onClick={function (e) { e.stopPropagation(); }}
							  >
								<DownloadIcon size={18} onClick={function () { window.open(invoice.invoice_pdf); }} />
							  </IconButton>
							</Tooltip>
						  </td>
						  <td>{moment.unix(invoice.period_start).format('L LT')}</td>
						  <td>${(invoice.amount_due / 100).toFixed(2)}</td>
						  <td>
							{invoice.lines && invoice.lines.data && invoice.lines.data.map(function (line, i) {
							  return <div key={i}>{_capitalizeText(line.description)} Plus Tax</div>;
							})}
						  </td>
						  <td>
							<a href={invoice.hosted_invoice_url} target="_blank" rel="noopener noreferrer" style={{ color: '#9600BF' }}>
							  {invoice.number}
							</a>
						  </td>
						  <td>
							{invoice.status === 'paid' ? (
							  <Badge color="success">
								{invoice.lines && invoice.lines.data && invoice.lines.data[0] &&
								  invoice.lines.data[0].description.indexOf('Trial') >= 0
								  ? 'Trial'
								  : _capitalizeText(invoice.status)}
							  </Badge>
							) : (
							  <Badge>{invoice.status}</Badge>
							)}
						  </td>
						</tr>
					  );
					})}
				  </tbody>
				</Table>
				<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
				  <Button disabled={startingAfterStack.length === 0} onClick={this._handlePrev}>Prev</Button>
				  <div style={{ paddingTop: '7px' }}>Page {startingAfterStack.length + 1}</div>
				  <Button disabled={!hasMore} onClick={this._handleNext}>Next</Button>
				</div>
			  </div>
			)}
		  </CardBody>
		</Card>
	  </Col>
	);
  }
}

Invoices.propTypes = {
  user: PropTypes.object.isRequired
};

export default Invoices;
